import React from "react";
//import PropTypes from "prop-types";
import config from "../../../content/meta/config";
import { rhythm, scale } from '../../utils/typography'
const Header = props => {
    // const { data, facebook } = props;
    // const postTitle = ((data || {}).frontmatter || {}).title;
    // const postDescription = ((data || {}).frontmatter || {}).description;
    // const postCover = ((data || {}).frontmatter || {}).cover;
    // const postSlug = ((data || {}).fields || {}).slug;

    // const title = postTitle ? `${postTitle} - ${config.shortSiteTitle}` : config.siteTitle;
    // const description = postDescription ? postDescription : config.siteDescription;
    // const image = postCover ? postCover.childImageSharp.resize.src : config.siteImage;
    // const url = config.siteUrl + config.pathPrefix + postSlug;
    // const divStyle = {
    //     border: '1px solid pink'
    // };
    const ulStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        listStyle: 'none',
        marginLeft: '0px'
    }

    return (
        <div style={{
            ...scale(0.3),
            marginBottom: rhythm(0.5),
            marginTop: 0,
            //position: 'fixed',
            // top: '0px',
            // left: '0px'
        }}>
            <ul style={ulStyle}>
                <li style={{
                    fontSize: '0.9rem'
                }}><a href="/">Home</a></li>
                <li style={{
                    fontSize: '0.9rem'
                }}><a href="/resume.pdf">Resume</a></li>
                <li style={{
                    fontSize: '0.9rem'
                }}><a href="/blog">Blog</a></li>
                <li style={{
                    fontSize: '0.9rem'
                }}><a href="/contact">Contact</a></li>
            </ul>
        </div>
    );
};

// Header.propTypes = {
//     data: PropTypes.object,
//     facebook: PropTypes.object.isRequired
// };

export default Header;



// WEBPACK FOOTER //
// ./src/components/Nav/Nav.js